import { get } from "../../xhr/api";

export const get_list_payments=(data,pageNum,filter)=> {
    return get('api/payment/listing?page='+pageNum+
    '&unit_code='+filter.unit_code+'&offset='+filter.offset,{},true);
}